import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["recordsEligible", "recordsEnrichable"];
import { BreezeIcon, LayoutHorizontal, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { ProgressMeter } from 'breeze-intelligence-kit/DataViz';
import { METER_BLOCK_SIZE } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MatchRate = _ref => {
  let {
      recordsEligible,
      recordsEnrichable
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutHorizontal, Object.assign({}, rest, {
    blockSize: METER_BLOCK_SIZE,
    children: /*#__PURE__*/_jsx(ProgressMeter, {
      limit: recordsEligible,
      value: recordsEnrichable,
      children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
        gap: "space-xs",
        children: [/*#__PURE__*/_jsx(BreezeIcon, {
          size: "xxs"
        }), /*#__PURE__*/_jsx(ProgressMeter.Percentage, {})]
      })
    })
  }));
};